import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {RatingStars} from '@frontend/features/common/components/RatingStars/RatingStars';
import {formatMiles} from '@frontend/features/common/helper';

interface RatingProps {
    rating?: number | null
    totalReviews?: number | null
}

const Rating: React.FC<RatingProps> = ({ rating, totalReviews }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  if (!rating || !totalReviews) return null;

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <RatingStars rating={rating} />
      <Typography variant="body1">{rating}</Typography>
      <Typography variant="caption" color={theme.palette.text.secondary}>
        {t('hotels.rating.opinion', {
          count: totalReviews,
          formattedCount: formatMiles(totalReviews),
        })}
      </Typography>
    </Box>
  );
};

export default Rating;
